import { render, staticRenderFns } from "./TherapistDashBookModal.vue?vue&type=template&id=52da5334&scoped=true"
import script from "./TherapistDashBookModal.vue?vue&type=script&lang=js"
export * from "./TherapistDashBookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da5334",
  null
  
)

export default component.exports